import React, { useEffect, useState } from "react";
import { Spin, Tooltip } from "antd";
import dayjs from "dayjs";

import CommonFooter from "../../../../../../core/common/footer/commonFooter";
import PropTypes from "prop-types";

import { Link } from "react-router-dom";
// import { Edit } from "feather-icons-react/build/IconComponents";
import NewExpense from "../../../Expenses/NewExpense";
import EditExpenses from "../../../Expenses/EditExpenses";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import Table from "../../../../../../core/pagination/datatable";

const ExpensesTab = ({ CustomerData }) => {
  const customerId = CustomerData?.customerId;

  const columns = [
    {
      title: "Category",
      dataIndex: "expense_category_name",
      render: (_, record) => {
        const expense_category_name = record.expense_category_name || "N/A";

        const truncatedNote =
          expense_category_name.length > 30
            ? `${expense_category_name.substring(0, 30)}...`
            : expense_category_name;

        return (
          <div className="d-flex align-items-start">
            <div className="ms-3">
              <div
                className="fw-semibold"
                title={expense_category_name}
                style={{ cursor: "pointer" }}
              >
                {truncatedNote}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Reason",
      dataIndex: "expense_name",

      render: (_, record) => (
        <>
          <div className="fw-semibold">{record.expense_name}</div>
        </>
      ),
    },

    {
      title: "Amount",
      dataIndex: "amount",

      render: (amount) => (
        <span className="fw-bold text-success">
          <i className="fa-solid fa-indian-rupee-sign me-2"></i>
          {amount}
        </span>
      ),
    },

    {
      title: "Date",

      render: (_, record) => (
        <>
          <div>{dayjs(record.date).format("DD-MM-YYYY") || "-"}</div>
        </>
      ),
    },
    {
      title: "Mode",
      dataIndex: "payment_mode_name",
      render: (payment_mode_name) => (
        <span
          className={`badge ${
            payment_mode_name === "UPI" ? "bg-soft-success" : "bg-soft-primary"
          }`}
        >
          {payment_mode_name}
        </span>
      ),
    },
    {
      title: "Expense Note",
      dataIndex: "note",
      render: (note) => {
        if (!note) return "-";

        const shortText =
          note.length > 20 ? `${note.substring(0, 20)}...` : note;

        return (
          <Tooltip title={note}>
            <span style={{ cursor: "pointer" }}>{shortText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Action",
      width: 70,
      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link to="/crm/expenseinfo" className="dropdown-item">
                <Eye className="text-info me-2" />
                View
              </Link>
            </li>

            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditExpense(record);
                }}
              >
                <Edit className="me-2 text-primary" />
                Edit
              </Link>
            </li>

            <li>
              <Link className="dropdown-item">
                <Trash2 className="text-danger me-2" />
                Delete
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
          <Link
                to="#"
                className="me-2 p-2  shadow-sm"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditExpense(record);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
             
              </Link>

            </div>
          </div>
        </>
      ),
    },
  ];

  const [expensesData, setExpensesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expensesCounts, setExpensesCounts] = useState({
    Total: "0",
    Billable: "0",
    NonBillable: "0",
    NotInvoiced: "0",
  });
  const [expenseDrawerOpen, setExpenseDrawerOpen] = useState(false);

  const handleExpenseClose = () => {
    setExpenseDrawerOpen(false);
  };

  const fetchExpensesCounts = async (Id) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}expenses/GetExpensCustCounts?Id=${Id}`,
      );

      const data = await response.json();

      if (data?.Status) {
        setExpensesCounts(data.ResultData?.[0] || {});
      }
    } catch (error) {
      console.error("Get Estimate Counts Error:", error);
    }
  };

  const getExpenses = async (Id) => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_CRM_URL}expenses/GetExpensesByCust/${Id}`,
      );

      if (response.data.Status) {
        setExpensesData(response.data.ResultData || []);

        fetchExpensesCounts(Id);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No expenses found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("expenses API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getExpenses(customerId);
    fetchExpensesCounts(customerId);
  }, [customerId]);

  const [editExpenseOpen, setEditExpenseOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);

  const handleEditExpense = (record) => {
    setSelectedExpense(record);
    setEditExpenseOpen(true);
  };

  const handleCloseEditExpense = () => {
    setEditExpenseOpen(false);
    setSelectedExpense(null);
  };



  return (
    <>
      <div>
        <div className="row g-3">
          {/* Total Expenses */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill shadow-sm revenue-widget">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">₹ {expensesCounts?.Total}</h4>
                  <p className="mb-0  fw-semibold">Total</p>
                </div>

                <div
                  className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40 }}
                >
                  <i className="fa-solid fa-wallet text-primary fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Billable */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill  shadow-sm revenue-widget">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">₹ {expensesCounts?.Billable}</h4>
                  <p className="mb-0  fw-semibold">Billable</p>
                </div>

                <div
                  className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40 }}
                >
                  <i className="fa-solid fa-file-invoice-dollar text-success fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Non Billable */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill shadow-sm revenue-widget">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    ₹ {expensesCounts?.NonBillable}
                  </h4>
                  <p className="mb-0  fw-semibold">Non Billable</p>
                </div>

                <div
                  className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40 }}
                >
                  <i className="fa-solid fa-receipt text-warning fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Not Invoiced */}
          {/* <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill shadow-sm revenue-widget">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    ₹ {expensesCounts?.NotInvoiced}
                  </h4>
                  <p className="mb-0  fw-semibold">Not Invoiced</p>
                </div>

                <div
                  className="rounded-circle bg-danger bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40 }}
                >
                  <i className="fa-solid fa-file-circle-xmark text-danger fs-4"></i>
                </div>
              </div>
            </div>
          </div> */}
        </div>

        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set">
         
            </div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-success btn-sm me-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setExpenseDrawerOpen(true);
                  }}
                >
                  <i className="ti ti-circle-plus fs-4 "> </i>
                </Link>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className=" table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={expensesData} />
              )}
            </div>
          </div>
        </div>

        <NewExpense
          open={expenseDrawerOpen}
          onClose={handleExpenseClose}
          getExpenses={getExpenses}
          customerId={customerId}
          type="customer"           
          onExpenseAdded={() => getExpenses(customerId)}
        />
        <EditExpenses
          open={editExpenseOpen}
          onClose={handleCloseEditExpense}
          getExpenses={getExpenses}
          record={selectedExpense}
          customerId={customerId}
          type="estimate"
          onExpenseAdded={() => getExpenses(customerId)}
        />
        <CommonFooter />
      </div>

      {/* <style>
        {`
        @media (max-width: 576px) {
          #offcanvasEditExpenses {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasEditExpenses {
            width: 60% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasEditExpenses {
            width: 35% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasEditExpenses {
            width: 23% !important;
          }
        }
        `}
      </style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasEditExpenses"
        aria-labelledby="offcanvasRightLabel"
       
      >
        <div className="offcanvas-header pb-0">
          <h4 id="offcanvasRightLabel">Edit Expenses</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body pt-0">
          <ul className="nav nav-tabs nav-tabs-bottom mb-3">
            <li className="nav-item">
              <Link
                className="nav-link active"
                to="#basic"
                data-bs-toggle="tab"
              >
                Basic
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="#advanced" data-bs-toggle="tab">
                Advanced
              </Link>
            </li>
          </ul>
          <div className="tab-content">
            <div className="tab-pane show active" id="basic">
              <Dragger>
                <div className="d-flex justify-content-center">
                  <p className="ant-upload-drag-icon me-2">
                    <i className="fa-brands fa-dropbox text-secondary fs-2"></i>
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload Receipts
                  </p>
                </div>
              </Dragger>
              <div className="row pt-2">
                <div className="col-6 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editExpense.name}
                    onChange={(e) =>
                      setEditExpense({
                        ...editExpense,
                        name: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Expense Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={editExpense.expenseDate}
                    onChange={(e) =>
                      setEditExpense({
                        ...editExpense,
                        expenseDate: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">Customer</label>
                  <Select
                    value={editExpense.customer}
                    style={{ width: "100%" }}
                    options={customers.map((customer) => ({
                      label: customer.name,
                      value: customer.id,
                    }))}
                    onChange={(value) =>
                      setEditExpense({
                        ...editExpense,
                        customer: value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Expense Category</label>
                  <Select
                    value={editExpense.expenseCategory}
                    style={{ width: "100%" }}
                    options={expenseCategories.map((category) => ({
                      label: category.name,
                      value: category.id,
                    }))}
                    onChange={(value) =>
                      setEditExpense({
                        ...editExpense,
                        expenseCategory: value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editExpense.amount}
                    onChange={(e) =>
                      setEditExpense({
                        ...editExpense,
                        amount: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Supplier</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editExpense.supplier}
                    onChange={(e) =>
                      setEditExpense({
                        ...editExpense,
                        supplier: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label">Note</label>
                  <textarea
                    className="form-control"
                    value={editExpense.note}
                    onChange={(e) =>
                      setEditExpense({
                        ...editExpense,
                        note: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="tab-pane" id="advanced">
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">Currency</label>
                  <Select
                    value={editExpense.currency}
                    style={{ width: "100%" }}
                    options={currencies.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    onChange={(value) =>
                      setEditExpense({
                        ...editExpense,
                        currency: value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Tax 1</label>
                  <Select
                    value={editExpense.tax1}
                    style={{ width: "100%" }}
                    options={taxOptions.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    onChange={(value) =>
                      setEditExpense({
                        ...editExpense,
                        tax1: value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Tax 2</label>
                  <Select
                    value={editExpense.tax2}
                    style={{ width: "100%" }}
                    options={taxOptions.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    onChange={(value) =>
                      setEditExpense({
                        ...editExpense,
                        tax2: value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Payment Mode</label>
                  <Select
                    value={editExpense.paymentMode}
                    style={{ width: "100%" }}
                    options={paymentTypes.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    onChange={(value) =>
                      setEditExpense({
                        ...editExpense,
                        paymentMode: value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Reference #</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editExpense.referenceNo}
                    onChange={(e) =>
                      setEditExpense({
                        ...editExpense,
                        referenceNo: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Repeat Every</label>
                  <Select
                    value={editExpense.repeatEvery}
                    style={{ width: "100%" }}
                    options={repeatOptions.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    onChange={(value) =>
                      setEditExpense({
                        ...editExpense,
                        repeatEvery: value,
                      })
                    }
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">Project</label>
                  <Select
                    value={editExpense.project}
                    style={{ width: "100%" }}
                    options={Projects.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    onChange={(value) =>
                      setEditExpense({
                        ...editExpense,
                        project: value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-secondary d-flex mt-3 me-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary mt-3"
              onClick={handleSaveExpense}
              data-bs-dismiss="offcanvas"
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <div>
        <style>
          {`
        @media (max-width: 576px) {
          #offcanvasRightNewExpense {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightNewExpense {
            width: 60% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightNewExpense {
            width: 35% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasRightNewExpense {
            width: 20% !important;
          }import { CustomerData } from './../../../../../../core/json/customer_data';

        }
        `}
        </style>
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="offcanvasRightNewExpense"
          aria-labelledby="offcanvasRightLabel"
        >
          <div className="offcanvas-header">
            <h4 id="offcanvasRightLabel">Add New Expense</h4>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
          <hr className="m-0" />
          <div className="offcanvas-body pt-0">
            <ul className="nav nav-tabs nav-tabs-bottom mb-3">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  to="#Addbasic"
                  data-bs-toggle="tab"
                >
                  Basic
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="#Addadvanced"
                  data-bs-toggle="tab"
                >
                  Advanced
                </Link>
              </li>
            </ul>
            <div className="tab-content">
              <div className="tab-pane show active" id="Addbasic">
                <Dragger>
                  <div className="d-flex justify-content-center">
                    <p className="ant-upload-drag-icon me-2">
                      <i className="fa-brands fa-dropbox text-secondary fs-2"></i>
                    </p>
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload Receipts
                    </p>
                  </div>
                </Dragger>
                <div className="row pt-2">
                  <div className="col-6 mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Expense Date</label>
                    <input type="date" className="form-control" />
                  </div>

                  <div className="col-6 mb-3">
                    <label className="form-label">Customer</label>
                    <Select
                      placeholder="Select Customer"
                      style={{ width: "100%" }}
                      allowClear
                      options={customers.map((customer) => ({
                        label: customer.name,
                        value: customer.id,
                      }))}
                      showSearch
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Expense Category</label>
                    <Select
                      placeholder="Select Expense Category"
                      style={{ width: "100%" }}
                      allowClear
                      options={expenseCategories.map((category) => ({
                        label: category.name,
                        value: category.id,
                      }))}
                      showSearch
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Amount</label>
                    <input type="number" className="form-control" />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Supplier</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label">Note</label>
                    <textarea type="text" className="form-control" />
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="Addadvanced">
                <div className="row">
                  <div className="col-6 mb-3">
                    <label className="form-label">Currency</label>
                    <Select
                      placeholder="Select Currency"
                      style={{ width: "100%" }}
                      allowClear
                      options={currencies.map((currency) => ({
                        label: currency.name,
                        value: currency.id,
                      }))}
                      showSearch
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Tax 1</label>
                    <Select
                      placeholder="Select Tax 1"
                      style={{ width: "100%" }}
                      allowClear
                      options={taxOptions.map((tax) => ({
                        label: tax.name,
                        value: tax.id,
                      }))}
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Tax 2</label>
                    <Select
                      placeholder="Select Tax 2"
                      style={{ width: "100%" }}
                      allowClear
                      options={taxOptions.map((tax) => ({
                        label: tax.name,
                        value: tax.id,
                      }))}
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Payment Mode</label>
                    <Select
                      placeholder="Select Payment Type"
                      style={{ width: "100%" }}
                      allowClear
                      options={paymentTypes.map((type) => ({
                        label: type.name,
                        value: type.id,
                      }))}
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Reference #</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Repeat Every</label>
                    <Select
                      placeholder="Repeat Every"
                      style={{ width: "100%" }}
                      allowClear
                      options={repeatOptions.map((option) => ({
                        label: option.name,
                        value: option.id,
                      }))}
                    />
                  </div>

                  <div className="col-6 mb-3">
                    <label className="form-label">Project </label>
                    <Select
                      placeholder="Repeat Every"
                      style={{ width: "100%" }}
                      allowClear
                      options={repeatOptions.map((option) => ({
                        label: option.name,
                        value: option.id,
                      }))}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary d-flex mt-3 me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary d-flex mt-3"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

ExpensesTab.propTypes = {
  CustomerData: PropTypes.object,
};

export default ExpensesTab;
